import { useQuery } from "react-query";
import { getOfficeApplianceBrands } from "../api/getOfficeApplianceBrands";
import { IOfficeAppliancesBrand } from "../type";

export default function useGetOfficeAppliancesBrand() {
  const { data, refetch } = useQuery<IOfficeAppliancesBrand[]>(
    ["GetOfficeApplianceBrands"],
    getOfficeApplianceBrands,
    { refetchOnWindowFocus: false }
  );

  return { data, refetch };
}
